export default __webpack_public_path__ + "static/media/icon-flag-danish.bc96acd5.svg";